import PubSub from 'pubsub-js';
import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const $html = $('html');
const $targetParentDom = '.content.-strength4';
const $targetParent = $($targetParentDom);
const $targetIntersection = '.content.-strength4 .-intersection';
const $contentLogoParent = $('.content__logoParent', $targetParent);
const $contentLink = $('.content__link', $targetParent);
const $contentInner = $('.content__itemInner', $targetParent);
const $contentSplide = $('.splide', $targetParent);

let isSplide = false;
let splide = null;

const play = () => {
  if (!isSplide) return;

  const autoScroll = splide.Components.AutoScroll;
  if(autoScroll.isPaused()) {
    autoScroll.play();
  }

}

const pause = () => {
  if (!isSplide) return;

  const autoScroll = splide.Components.AutoScroll;
  autoScroll.pause();
}


const intersection = () => {
  const targets = document.querySelectorAll(`${$targetIntersection}`);

  const options = {
    root: null,
    rootMargin: '0px 0px',
    threshold: 0.5,
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        play();
          if (!$(entry.target).hasClass('-intersectionIsEntry')) {
            $(entry.target).addClass('-intersectionIsEntry');
          }
      } else {
        pause();
      }
    });
  }, options);

  targets.forEach(target => {
    observer.observe(target);
  });
};

PubSub.subscribe('init', () => {
    const device = $html.data('device');
    if (device === 'mobile') {
        intersection();
    }

    isSplide = $contentSplide.get(0);
    if (isSplide) {
      splide = new Splide(`${$targetParentDom} .splide`, {
        type: 'loop',
        pauseOnHover: false,
        pauseOnFocus: false,
        drag: false,
        autoWidth: true,
        arrows: false,
        pagination: false,
        autoScroll: {
          pauseOnHover: false,
          pauseOnFocus: false,
          autoStart: false,
          rewind: true,
        }
      }).mount({ AutoScroll });
    }
});

PubSub.subscribe('top.strength4.show', () => {
  play();
  $contentLogoParent.addClass('-intersectionIsEntry');
  $contentLink.addClass('-intersectionIsEntry');
  $contentInner.addClass('-intersectionIsEntry');
});

PubSub.subscribe('top.strength4.hide', () => {
  pause();
  $contentLogoParent.removeClass('-intersectionIsEntry');
  $contentLink.removeClass('-intersectionIsEntry');
  $contentInner.removeClass('-intersectionIsEntry');
});